/**
Project: Voice Panel (c)
Title: Constants
Description: Constants used for voice admin Redux store
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/

// General
export const SUBSCRIBER_IDENTITY = "SUBSCRIBER_IDENTITY";
export const SUBSCRIBER_ACCOUNT = "SUBSCRIBER_ACCOUNT";
export const SUBSCRIBER_MENUS = "SUBSCRIBER_MENUS";
export const PAGE_WAIT_DIALOG_DATA = "PAGE_WAIT_DIALOG_DATA";
export const COUNTRY_STATES_DATA = "COUNTRY_STATES_DATA";
export const USER_CONSENT_DATA = "USER_CONSENT_DATA";

// Voice-Setup
export const VOICE_SETUP_PROGRESS_PAGE = "VOICE_SETUP_PROGRESS_PAGE";
export const VOICE_SETUP_PROGRESS_ACCOUNT_ID =
  "VOICE_SETUP_PROGRESS_ACCOUNT_ID";
export const VOICE_SETUP_PROGRESS_VOICE_REGIONS =
  "VOICE_SETUP_PROGRESS_VOICE_REGIONS";
export const VOICE_SETUP_DATA_RESET = "VOICE_SETUP_DATA_RESET";

// Domain-Setup
export const DOMAIN_SETUP_PROGRESS_PAGE = "DOMAIN_SETUP_PROGRESS_PAGE";
export const DOMAIN_SETUP_PROGRESS_ACCOUNT_ID =
  "DOMAIN_SETUP_PROGRESS_ACCOUNT_ID";
export const DOMAIN_SETUP_PROGRESS_DOMAIN_REGIONS =
  "DOMAIN_SETUP_PROGRESS_DOMAIN_REGIONS";
export const DOMAIN_SETUP_PROCESS_DOMAIN_RECORD =
  "DOMAIN_SETUP_PROCESS_DOMAIN_DNS_RECORD";
export const DOMAIN_SETUP_PROCESS_UPDATE_DOMAIN_RECORD =
  "DOMAIN_SETUP_PROCESS_UPDATE_DOMAIN_DNS_RECORD";
export const DOMAIN_SETUP = "DOMAIN_SETUP";
export const DOMAIN_CREATE_USERS = "CREATE_USERS";

// Routing
export const ROUTING_POLICIES = "ROUTING_POLICIES";
export const SELECT_ROUTING_POLICY = "SELECT_ROUTING_POLICY";
export const VOICE_ROUTES = "VOICE_ROUTES";
export const INCREMENT_VOICE_ROUTE_PRIORITY = "INCREMENT_VOICE_ROUTE_PRIORITY";
export const DECREMENT_VOICE_ROUTE_PRIORITY = "DECREMENT_VOICE_ROUTE_PRIORITY";
export const UPDATE_VOICE_ROUTE_PRIORITY = "UPDATE_VOICE_ROUTE_PRIORITY";
export const ASSIGN_VOICE_ROUTE = "ASSIGN_VOICE_ROUTE";
export const UNASSIGN_VOICE_ROUTE = "UNASSIGN_VOICE_ROUTE";
export const ENABLE_VOICE_ROUTES_UPDATE_BUTTON =
  "ENABLE_VOICE_ROUTES_UPDATE_BUTTON";
export const DISABLE_VOICE_ROUTES_UPDATE_BUTTON =
  "DISABLE_VOICE_ROUTES_UPDATE_BUTTON";
export const ROUTING_DATA_RESET = "ROUTING_DATA_RESET";
export const SET_VOICE_ROUTES="SET_VOICE_ROUTES";

// Users
export const USERS_ROUTING_POLICIES = "USERS_ROUTING_POLICIES";
export const USERS_ALL_RECORDS = "USERS_ALL_RECORDS";
export const USERS_DISPLAY_RECORDS = "USERS_DISPLAY_RECORDS";
export const USERS_PAGE_RECORDS = "USERS_PAGE_RECORDS";
export const USERS_UPDATE_RECORDS = "USERS_UPDATE_RECORDS";
export const USER_PHONE_NUMBER_TO_ALTER = "USER_PHONE_NUMBER_TO_ALTER";
export const USER_ROUTING_POLICY_TO_ALTER = "USER_ROUTING_POLICY_TO_ALTER";
export const ALTER_USER_PHONE_NUMBER = "ALTER_USER_PHONE_NUMBER";
export const ALTER_USER_ROUTING_POLICY = "ALTER_USER_ROUTING_POLICY";
export const ALTER_USER_CHECKBOX_STATUS = "ALTER_USER_CHECKBOX_STATUS";
export const USERS_DATA_RESET = "USERS_DATA_RESET";
export const SET_USER_PHONE_NUMBER = "SET_USER_PHONE_NUMBER";

// Service Numbers
export const SERVICE_NUMBERS_ROUTING_POLICIES =
  "SERVICE_NUMBERS_ROUTING_POLICIES";
export const SERVICE_NUMBERS_ALL_RECORDS = "SERVICE_NUMBERS_ALL_RECORDS";
export const SERVICE_NUMBERS_DISPLAY_RECORDS =
  "SERVICE_NUMBERS_DISPLAY_RECORDS";
export const SERVICE_NUMBERS_PAGE_RECORDS = "SERVICE_NUMBERS_PAGE_RECORDS";
export const SERVICE_NUMBERS_UPDATE_RECORDS = "SERVICE_NUMBERS_UPDATE_RECORDS";
export const SERVICE_NUMBER_PHONE_NUMBER_TO_ALTER =
  "SERVICE_NUMBER_PHONE_NUMBER_TO_ALTER";
export const SERVICE_NUMBER_ROUTING_POLICY_TO_ALTER =
  "SERVICE_NUMBER_ROUTING_POLICY_TO_ALTER";
export const ALTER_SERVICE_NUMBER_PHONE_NUMBER =
  "ALTER_SERVICE_NUMBER_PHONE_NUMBER";
export const ALTER_SERVICE_NUMBER_ROUTING_POLICY =
  "ALTER_SERVICE_NUMBER_ROUTING_POLICY";
export const SERVICE_NUMBERS_DATA_RESET = "SERVICE_NUMBERS_DATA_RESET";

// Admin-Department
export const DEPARTMENT_ALL_RECORDS = "DEPARTMENTS_ALL_RECORDS";
export const DEPARTMENT_DISPLAY_RECORDS = "DEPARTMENTS_DISPLAY_RECORDS";
export const DEPARTMENT_PAGE_RECORDS = "DEPARTMENTS_PAGE_RECORDS";

// Admin-NumberTypes
export const NUMBERTYPES_ALL_RECORDS = "NUMBERTYPES_ALL_RECORDS";
export const NUMBERTYPES_DISPLAY_RECORDS = "NUMBERTYPES_DISPLAY_RECORDS";
export const NUMBERTYPES_PAGE_RECORDS = "NUMBERTYPES_PAGE_RECORDS";

// Admin-Carriers
export const CARRIERS_ALL_RECORDS = "CARRIERS_ALL_RECORDS";
export const CARRIERS_DISPLAY_RECORDS = "CARRIERS_DISPLAY_RECORDS";
export const CARRIERS_PAGE_RECORDS = "CARRIERS_PAGE_RECORDS";

// Admin-DeviceTypes
export const DEVICETYPES_ALL_RECORDS = "DEVICETYPES_ALL_RECORDS";
export const DEVICETYPES_DISPLAY_RECORDS = "DEVICETYPES_DISPLAY_RECORDS";
export const DEVICETYPES_PAGE_RECORDS = "DEVICETYPES_PAGE_RECORDS";

//Inventory
export const INVENTORY_NUMBERS_ALL_RECORDS = "INVENTORY_NUMBERS_ALL_RECORDS";
export const INVENTORY_NUMBERS_DISPLAY_RECORDS =
  "INVENTORY_NUMBERS_DISPLAY_RECORDS";
export const INVENTORY_NUMBERS_PAGE_RECORDS = "INVENTORY_NUMBERS_PAGE_RECORDS";
export const INVENTORY_NUMBERS_DATA_RESET = "INVENTORY_NUMBERS_DATA_RESET";
export const INVENTORY_NUMBERS_DEPARTMENTS_RECORDS =
  "INVENTORY_NUMBERS_DEPARTMENTS_RECORDS";
export const INVENTORY_NUMBERS_TYPES_RECORDS =
  "INVENTORY_NUMBERS_TYPES_RECORDS";
export const INVENTORY_NUMBERS_CARRIERS_RECORDS =
  "INVENTORY_NUMBERS_CARRIERS_RECORDS";
export const INVENTORY_DEVICE_MAKE_MODEL_DATA = "NUMBER_DEVICE_MAKE_MODEL_DATA";
export const COMMUNICATION_PLATFORMS_DATA = "COMMUNICATION_PLATFORMS_DATA";



//Number-Order
export const NUMBER_ORDERED_RECORDS = "NUMBER_ORDERED_RECORDS";
